import React from 'react';
import './style.sass';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import parse from 'html-react-parser';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';

const devRecList = [
    {
        val: '5200+',
        text: 'часов поддержки за&nbsp;6&nbsp;месяцев',
    },
    {
        val: '<15 минут',
        text: 'время реакции при обращении',
    },
    {
        val: '8 человек',
        text: 'осуществляют поддержку',
    },
];

const devRecList2 = [
    {
        val: '13 человек',
        text: 'в&nbsp;команде, работающей над проектом',
    },
    {
        val: '2200 +',
        text: 'коммитов с&nbsp;доработками и&nbsp;новым функционалом',
    },
    {
        val: '20%',
        text: 'экономия ресурсов HR',
    },
    {
        val: '50',
        text: 'рабочих часов&nbsp;&mdash; экономия рабочего времени сотрудника ежемесячно',
    },
];

const Numbers = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper caseName="dev-rec-numbers" bigPaddings={true}>
                <CommonTitle className="dev-rec-numbers__title">Цифры</CommonTitle>
                <div className="dev-rec-numbers__wrapper">
                    <div className="dev-rec-numbers__row">
                        <CommonSmallTitle className="dev-rec-numbers__row-title">
                            Техподдержка
                        </CommonSmallTitle>
                        <div className="dev-rec-numbers__grid dev-rec-numbers__grid--space">
                            {devRecList.map((item, index) => {
                                return (
                                    <div
                                        className="dev-rec-numbers__item dev-rec-numbers__item--big"
                                        key={index}
                                    >
                                        <div className="dev-rec-numbers__item-val">{item.val}</div>
                                        <CommonSmallText className="dev-rec-numbers__item-content">
                                            {parse(item.text)}
                                        </CommonSmallText>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="dev-rec-numbers__row">
                        <CommonSmallTitle className="dev-rec-numbers__row-title">
                            Модернизация
                        </CommonSmallTitle>
                        <div className="dev-rec-numbers__grid">
                            {devRecList2.map((item, index) => {
                                return (
                                    <div className="dev-rec-numbers__item" key={index}>
                                        <div className="dev-rec-numbers__item-val">{item.val}</div>
                                        <CommonSmallText className="dev-rec-numbers__item-content">
                                            {parse(item.text)}
                                        </CommonSmallText>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Numbers;
